const RECENT_SEARCHES_KEY = 'globalSearch:recent'
const MAX_RECENT_SEARCHES = 8

export const getRecentSearches = () => {
    try {
        return JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY) || '[]')
    } catch {
        return []
    }
}

export const addRecentSearch = (query) => {
    if (!query?.trim()) return
    const recent = getRecentSearches().filter((q) => q !== query)
    recent.unshift(query)
    localStorage.setItem(
        RECENT_SEARCHES_KEY,
        JSON.stringify(recent.slice(0, MAX_RECENT_SEARCHES))
    )
}

export const removeRecentSearch = (query) => {
    const recent = getRecentSearches().filter((q) => q !== query)
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(recent))
}
